import emailjs from "emailjs-com";
const PRIMARY_SERVICE_ID = "service_c8i7gyc";
const BACKUP_SERVICE_ID = "service_2us1vwk";
const isProviderRateLimit = (error) =>
  /\buser[-\s]rate\s+limit\s+exceeded\b/i.test(
    [typeof error === "string" ? error : "", error?.text, error?.message].filter(Boolean).join(" "),
  );
export function createFallbackSender(
  send,
  wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
) {
  let backupQueue = Promise.resolve();
  return async (serviceId, ...args) => {
    try {
      return await send(serviceId, ...args);
    } catch (error) {
      if (serviceId !== PRIMARY_SERVICE_ID || !isProviderRateLimit(error)) throw error;
      // Keep the two provider requests apart for EmailJS's per-second limit.
      const attempt = backupQueue.then(async () => {
        await wait(1100);
        return send(BACKUP_SERVICE_ID, ...args);
      });
      // Serialize backup attempts within this process/page, including failures.
      backupQueue = attempt.catch(() => {});
      return attempt;
    }
  };
}
const emailjsWithFallback = {
  ...emailjs,
  send: createFallbackSender((...args) => emailjs.send(...args)),
};
export default emailjsWithFallback;
